import PropTypes from 'prop-types';

const ProtectedRoutes = ({ children }) => children;

ProtectedRoutes.propTypes = {
  children: PropTypes.node,
};

export default ProtectedRoutes;
